import React, { useState } from 'react';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { ItemToReturn } from '../../models/returns';
import ReturnReviewCard from '../shared/summary-cards/ReturnReviewCard';
import ReviewItemDetails from './ReviewItemDetails';
import NumberOfBoxesDrawer from './drawer/NumberOfBoxesDrawer';

interface UPSDropOffCardProps {
  items: ItemToReturn[];
  returnBoxes?: number;
  onEditItemSubmit: (
    startingState: ItemToReturn,
    closeDrawer: () => void,
  ) => void;
  onRemoveItemSubmit: (selectedItemId: string) => void;
  isPolicyValidatorLoading: boolean;
}

export const UPSDropOffCard = ({
  items,
  returnBoxes,
  onEditItemSubmit,
  onRemoveItemSubmit,
  isPolicyValidatorLoading,
}: UPSDropOffCardProps) => {
  const [displayNumberOfBoxesDrawer, setDisplayNumberOfBoxesDrawer] =
    useState(false);

  const openNumberOfBoxes = () => {
    setDisplayNumberOfBoxesDrawer(true);
  };
  return (
    <ReturnReviewCard header="UPS Drop-Off">
      {/* Items List */}
      <div className="sui-space-y-6">
        {items.map((item, index) => (
          <div
            key={`${item.lineItemId}-${index}`}
            className="sui-flex sui-items-start sui-gap-4"
          >
            <ReviewItemDetails
              item={item}
              index={index}
              onEditItemSubmit={onEditItemSubmit}
              onRemoveItemSubmit={onRemoveItemSubmit}
              isPolicyValidatorLoading={isPolicyValidatorLoading}
              key={`${item.lineItemId}-${index}`}
            />
          </div>
        ))}
      </div>

      {/* Number of Boxes Section */}
      <div className="sui-mt-6">
        <hr />
        <div className="sui-mt-6">
          <div className="sui-flex sui-justify-between sui-items-start">
            <Typography weight="bold">Number of Boxes</Typography>
            <Link onClick={openNumberOfBoxes}>Edit</Link>
          </div>
          <Typography className="sui-text-xs sui-text-gray-600 sui-mt-1">
            Qty: {returnBoxes}
          </Typography>
        </div>
      </div>
      <NumberOfBoxesDrawer
        displayDrawer={displayNumberOfBoxesDrawer}
        closeDrawer={() => setDisplayNumberOfBoxesDrawer(false)}
      />
    </ReturnReviewCard>
  );
};
